import "../../../../assets/css/screens/customer/dashboard/profilesetting/ProfileSetting.css";

import React, { useState, useEffect, useRef, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, User, Mail, Phone, MapPin, Camera, CheckCircle, Lock, Home } from 'lucide-react';
import AppNavbar from '../../../../components/customer/dashboard/apphome/appnavbar/AppNavbar';
import axios from 'axios';
import AppContext from "../../../../context/AppContext";

const EditProfile = () => {
 const {baseUrl, baseUrlForFile} = useContext(AppContext);
  const navigate = useNavigate();
  const [customerName, setCustomerName] = useState("");
  const [customerEmail, setCustomerEmail] = useState("");
  const [customerPhone, setCustomerPhone] = useState("");
  const [customerCity, setCustomerCity] = useState("");
  const [customerAddress, setCustomerAddress] = useState("");
  const [customerBio, setCustomerBio] = useState("");


  const fileInputRef = useRef(null);
  const [formData, setFormData] = useState({});
  const [preview, setPreview] = useState(null);

  const handleImageClick = () => {
    fileInputRef.current.click();
  };


  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      setFormData(prev => ({ ...prev, avatar: file }));
      setPreview(URL.createObjectURL(file));
    }
  };


  // update profile
 const updateProfile = () => {
  const form = new FormData();

  form.append("fullName", customerName);
  form.append("email", customerEmail);
  form.append("phoneNumber", customerPhone);
  form.append("city", customerCity);
  form.append("Address", customerAddress);
  form.append("Bio", customerBio);

 

  if (formData.avatar) {
    form.append("ProfileImage", formData.avatar);
  }

  axios.post(`${baseUrl}/customer/updateProfile`, form, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("authToken")}`,
      "Content-Type": "multipart/form-data"
    }
  })
  .then((res) => {
    if (res.data.success) {
      setShowAlert(true);
    } else {
      alert(res.data.message || "Update failed");
    }
  })
  .catch((err) => {
    console.log("Update Error:", err);
    alert("Update failed");
  });
};




  // View profile

 const viewProfile = () => {
  axios.get(`${baseUrl}/customer/viewProfile`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("authToken")}`
    }
  })
  .then((res) => {
    const data = res.data.customer;
    console.log(data.ProfileImage);
console.log(baseUrlForFile);
console.log(
  `${baseUrlForFile}/storage/${data.ProfileImage}`
);

    setCustomerName(data.fullName || "");
    setCustomerEmail(data.email || "");
    setCustomerPhone(data.phoneNumber || "");
    setCustomerCity(data.city || "");
    setCustomerAddress(data.Address || "");
    setCustomerBio(data.Bio || "");

 if (data.ProfileImage) {
  setPreview(
    `${baseUrlForFile}/${data.ProfileImage}`
  );
}
  })
  .catch((err) => console.log(err));
};

useEffect(() => {
  if (baseUrl) {
    viewProfile();
  }
}, [baseUrl, baseUrlForFile]);
  const [showAlert, setShowAlert] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleAlertClose = () => {
    setShowAlert(false);
    navigate('/profile-settings');
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <>
      <AppNavbar />

      <div className="edit-profile-page">

        <div className="edit-profile-header">
          <button className="edit-profile-back" onClick={handleBack}>
            <ArrowLeft size={24} />
          </button>
          <h2 className="edit-profile-title">Edit Profile</h2>
        </div>

        <div className="edit-profile-content">

          {/* ⭐ AVATAR (NOW CLICKABLE) */}
          <div className="edit-profile-avatar-section">

            <div
              className="edit-profile-avatar"
              onClick={handleImageClick}
              style={{ cursor: "pointer" }}
            >
              {preview ? (
               <img
  src={preview}
  alt="avatar"
  onError={(e) => {
    console.log("Image Error:", e.target.src);
  }}
  style={{
    width: "100%",
    height: "100%",
    borderRadius: "50%",
    objectFit: "cover"
  }}
/>
              ) : (
                <span className="edit-profile-initials">JD</span>
              )}

              <button className="edit-profile-avatar-edit">
                <Camera size={16} />
              </button>
            </div>

            {/* hidden input */}
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleImageChange}
              style={{ display: "none" }}
              accept="image/*"
            />
          </div>

          {/* FORM SAME AS YOUR CODE */}
          <div className="edit-profile-form">

            <div className="edit-profile-field">
              <label className="edit-profile-label">
                <User size={16} /> Full Name
              </label>
              <input
                type="text"
                name="fullName"
                className="edit-profile-input"
                value={customerName}
                onChange={e => setCustomerName(e.target.value)}
              />
            </div>

            <div className="edit-profile-field">
              <label className="edit-profile-label">
                <Mail size={16} /> Email
              </label>
              <input
                type="email"
                name="email"
                className="edit-profile-input"
                value={customerEmail}
                onChange={e => setCustomerEmail(e.target.value)}
              />
            </div>

            <div className="edit-profile-field">
              <label className="edit-profile-label">
                <Phone size={16} /> Phone
              </label>
              <input
                type="tel"
                name="phone"
                className="edit-profile-input"
                value={customerPhone}
                onChange={e => setCustomerPhone(e.target.value)}
              />
            </div>

            <div className="edit-profile-field">
              <label className="edit-profile-label">
                <MapPin size={16} /> City
              </label>
              <input
                type="text"
                name="city"
                className="edit-profile-input"
                value={customerCity}
                onChange={e => setCustomerCity(e.target.value)}
              />
            </div>

            <div className="edit-profile-field">
              <label className="edit-profile-label">
                <Home size={16} /> Address
              </label>
              <input
                type="text"
                name="address"
                className="edit-profile-input"
                value={customerAddress}
                onChange={e => setCustomerAddress(e.target.value)}
              />
            </div>

         
              

          

            <div className="edit-profile-field">
              <label className="edit-profile-label-text">Bio</label>
              <textarea
                name="bio"
                className="edit-profile-textarea"
                value={customerBio}
                onChange={e => setCustomerBio(e.target.value)}
              />
            </div>

          </div>

          <button className="edit-profile-save-btn" onClick={updateProfile}>
            Save Changes
          </button>

        </div>
      </div>

      {/* SWEET ALERT */}
      {showAlert && (
        <div className="psa-overlay" onClick={handleAlertClose}>
          <div className="psa-box" onClick={(e) => e.stopPropagation()}>

            <div className="psa-icon-wrap">
              <div className="psa-icon-ring" />
              <CheckCircle size={38} className="psa-icon" />
            </div>

            <h3 className="psa-heading">Profile Updated!</h3>
            <p className="psa-msg">
              Your profile has been saved successfully.
            </p>

            <button className="psa-btn" onClick={handleAlertClose}>
              Continue
            </button>

          </div>
        </div>
      )}


    </>
  );
};

export default EditProfile;


